import { Box, Grid2, IconButton, Paper, Typography } from "@mui/material"
import CreateVisualizationDialog from "./CreateVisualizationDialog";
import GraphIcon from "./../Common/GraphIcon";
import { Close } from "@mui/icons-material";

const CreateChartPlaceholder = ({ entityKey, entityIndex, totalEntitiesCount, batteryID, selectedDate, onClose, onCreateClick, batteryInfo = {}, selectedEntity = null }) => {

    const isDisabled = !Boolean(batteryID);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Paper elevation={0} sx={{ width: 'fit-content', px: 1.5, py: 1, borderRadius: 0, borderTopLeftRadius: 8, borderTopRightRadius: 8, border: "1px solid #EAEAEA", borderBottom: 'none' }}>
                <Grid2 container gap={1} alignItems={'center'}>
                    <Typography variant="fw500s12lh20c000000">Visualization {entityIndex + 1}</Typography>
                    {totalEntitiesCount > 1 && <IconButton
                        onClick={onClose}
                        sx={{
                            p: 0.5,
                            '&:hover': {
                                backgroundColor: '#E6E6E6',
                                'svg': {
                                    stroke: '#930500'
                                }
                            },
                            '&:focus': {
                                backgroundColor: '#E6E6E6',
                                'svg': {
                                    stroke: '#930500'
                                }
                            }
                        }}
                    >
                        <Close color={'#494949'} sx={{ height: '12px', width: '12px', stroke: '#686868' }} />
                    </IconButton>}
                </Grid2>
            </Paper>
            <Paper elevation={0} sx={{ borderRadius: 3, borderTopLeftRadius: 0, border: "1px solid #EAEAEA", height: '517px' }}>
                <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', p: 3 }}>
                    <Box sx={{ display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center', flexDirection: 'column', width: '100%' }}>
                        <GraphIcon
                            isSelected={!isDisabled}
                            style={{ width: 262, height: 107 }}
                        />
                        <Typography variant="fw400s12c686868" sx={{ lineHeight: '16px', mb: 2, color: isDisabled ? '#A2A2A2' : '#686868' }}>Create your first visualisation</Typography>
                        <CreateVisualizationDialog
                            chartId={`preview-continuous-${entityKey}`}
                            batteryID={batteryID}
                            selectedDate={selectedDate}
                            onSaveChart={(entities, events) => onCreateClick(entityKey, entities, events)}
                            batteryInfo={batteryInfo}
                            selectedEntity={selectedEntity}
                        />
                    </Box>
                </Box>
            </Paper>
        </Box>
    )
}

export default CreateChartPlaceholder;
